var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8414_17223)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_8414_17223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4984 5.84355L12.4955 5.87047V5.89755C12.4955 6.03939 12.3783 6.13849 12.2733 6.13849H11.551H11.0489L11.051 6.64063L11.0668 10.3363C11.0668 10.3366 11.0668 10.3369 11.0668 10.3372C11.0668 10.3756 11.064 10.4187 11.0585 10.4693L11.0556 10.4962V10.5233V10.8949C11.0556 11.1395 10.8649 11.3182 10.6528 11.3182H10.2917L10.266 11.318C10.2641 11.318 10.2628 11.3179 10.2622 11.3179L10.2222 11.3142L10.1807 11.3172C10.1704 11.318 10.157 11.3182 10.1224 11.3182H9.38889H8.84722C8.63511 11.3182 8.44444 11.1395 8.44444 10.8949V10.3409V8.86364C8.44444 8.18959 7.90838 7.625 7.22222 7.625H5.77778C5.09162 7.625 4.55556 8.18959 4.55556 8.86364V10.3409V10.8949C4.55556 11.1395 4.36489 11.3182 4.15278 11.3182H3.61111H2.89115C2.87717 11.3182 2.86033 11.3172 2.82359 11.3147L2.78534 11.3121L2.74713 11.3154C2.73269 11.3166 2.72443 11.3173 2.71706 11.3178C2.7107 11.3182 2.70827 11.3182 2.7083 11.3182H2.34722C2.13511 11.3182 1.94444 11.1395 1.94444 10.8949V8.30966L1.94447 8.29698L1.94454 8.29204L1.9467 8.27211V8.24503V6.63849V6.13849H1.4467H0.722222C0.603659 6.13849 0.5 6.05089 0.5 5.89755C0.5 5.81841 0.518836 5.76291 0.573569 5.70329L6.34522 0.55788L6.35802 0.546474L6.37 0.534218C6.3799 0.524094 6.38701 0.519234 6.39114 0.516759C6.39539 0.514222 6.40033 0.511922 6.40742 0.509745C6.42381 0.504718 6.45202 0.5 6.50903 0.5C6.54093 0.5 6.57419 0.504869 6.60321 0.51408C6.62927 0.522351 6.64604 0.532179 6.65587 0.53985L12.4129 5.71541L12.4138 5.71617C12.4654 5.76235 12.4856 5.79544 12.493 5.81158C12.4986 5.82386 12.4997 5.83148 12.4984 5.84355Z",
    stroke: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8414_17223",
    x: -0.5,
    y: -0.5,
    width: 14,
    height: 12.8184,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_8414_17223"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8414_17223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 11.8182,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.db996c4201a66055a34e20d4fa58673b.svg";
export { ForwardRef as ReactComponent };